import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';
import { alert, custom } from 'devextreme/ui/dialog';
import { from } from 'rxjs';

export enum MessageButton {
  CANCEL,
  CLOSE,
  CONFIRM,
  NO,
  OK,
  YES,
}

@Injectable({ providedIn: 'root'})
export class MessageService {

  constructor() {
  }
  messages: string[] = [];
  // debugFlag = false;
  config = {
    displayTime: 7000,
    position: {at: 'bottom right', my: 'bottom right', offset: '-10 -20'},
    closeOnClick: true,
    maxWidth: '568px',
    message: '',
  };

  private button(type: MessageButton) {
    return {
      text: MessageButton[type],
      onClick: (e) => type,
    };
  }

  error(message: string, title?: string, ...optionalParams: any[]) {
    title = title || 'Error';
    this.config.message = message;
    notify(this.config, 'error');
    this.log(`${title}: ${message}`, optionalParams);
  }

  info(message: string, title?: string, ...optionalParams: any[]) {
    title = title || 'Information';
    this.config.message = message;
    notify(this.config, 'info');
    this.log(`${title}: ${message}`, optionalParams);
  }

  success(message: string, title?: string, ...optionalParams: any[]) {
    title = title || 'Success';
    this.config.message = message;
    notify(this.config, 'success');
    this.log(`${title}: ${message}`, optionalParams);
  }

  warning(message: string, title?: string, ...optionalParams: any[]) {
    title = title || 'Warning';
    this.config.message = message;
    notify(this.config, 'warning');
    this.log(`${title}: ${message}`, optionalParams);
  }

  alert(messageHtml: string, title?: string) {
    return from(alert(messageHtml, title));
  }

  ok(messageHtml: string, title?: string) {
    return this.alert(messageHtml, title);
  }

  yesNo(messageHtml: string, title?: string) {
    return from(custom({
      title: title,
      messageHtml: messageHtml,
      buttons: [{
        text: MessageButton[MessageButton.YES],
        onClick: (e) => true,
      },
      {
        text: MessageButton[MessageButton.NO],
        onClick: (e) => false,
      }, ]
    }).show());
  }

  yesNoCancel(messageHtml: string, title?: string) {
    return from(custom({
      title: title,
      messageHtml: messageHtml,
      buttons: [this.button(MessageButton.YES), this.button(MessageButton.NO), this.button(MessageButton.CANCEL)]
    }).show());
  }

  add(message: string, title?: string, ...optionalParams: any[]) {
    // TODO: this.messages.push(message);
    if (title === 'Debug' || title === 'Info') {
      // Do not log debug or info messages
      return;
    }

    if (title) {
      title = title + ': ';
    }
    this.log(`${title}${message}`, optionalParams);
  }

  clear() {
    this.messages = [];
  }

  log(message: any, ...optionalParams: any[]) {
    // tslint:disable-next-line:only-arrow-functions
    const flatten = function(arr, result = []) {
      for (let i = 0, length = arr.length; i < length; i++) {
        const value = arr[i];
        if (Array.isArray(value)) {
          flatten(value, result);
        } else {
          result.push(value);
        }
      }
      return result;
    };
    // if (this.debugFlag && this.debugFlag === true) {
    //   const objs = flatten(optionalParams);
    //   if (objs.length > 0) {
    //     console.log(message, objs);
    //   } else {
    //     console.log(message);
    //   }
    // }
  }
}
